const ConversationalistSvg = ({
   width = 33,
   height = 33,
   fill = 'white',
}: {
   width?: number
   height?: number
   fill?: string
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 33 33"
      fill="none"
   >
      <g clipPath="url(#clip0_164_924)">
         <path
            d="M25.9974 6.31283H24.5294C23.9094 3.27416 21.2161 0.979492 17.9974 0.979492H7.33073C3.65473 0.979492 0.664062 3.97016 0.664062 7.64616V24.7848C0.664062 25.8435 1.24406 26.8115 2.17606 27.3102C2.60006 27.5382 3.0654 27.6502 3.5294 27.6502C4.08406 27.6502 4.6374 27.4888 5.11606 27.1702L9.0494 24.5475C9.97073 27.1275 12.4374 28.9795 15.3307 28.9795H22.9267L28.2121 32.5035C28.6921 32.8235 29.2441 32.9848 29.7987 32.9848C30.2627 32.9848 30.7267 32.8715 31.1521 32.6435C32.0854 32.1448 32.6641 31.1768 32.6641 30.1182V12.9795C32.6641 9.30349 29.6734 6.31283 25.9974 6.31283ZM3.6374 24.9515C3.61206 24.9675 3.5374 25.0155 3.43473 24.9608C3.3294 24.9048 3.3294 24.8155 3.3294 24.7862V7.64616C3.3294 5.44083 5.12406 3.64616 7.3294 3.64616H17.9961C20.2014 3.64616 21.9961 5.44083 21.9961 7.64616V16.9795C21.9961 19.1848 20.2014 20.9795 17.9961 20.9795H9.99606C9.56006 20.9795 9.27473 21.1915 9.24273 21.2128L3.6374 24.9515ZM29.9974 30.1195C29.9974 30.1475 29.9974 30.2382 29.8921 30.2942C29.7867 30.3488 29.7147 30.3008 29.6907 30.2848L24.0707 26.5368C23.8521 26.3915 23.5947 26.3128 23.3307 26.3128H15.3307C13.5921 26.3128 12.1107 25.1982 11.5601 23.6462H17.9974C21.6734 23.6462 24.6641 20.6555 24.6641 16.9795V8.97949H25.9974C28.2027 8.97949 29.9974 10.7742 29.9974 12.9795V30.1195Z"
            fill={fill}
         />
      </g>
      <defs>
         <clipPath id="clip0_164_924">
            <rect
               width="32"
               height="32"
               fill="white"
               transform="translate(0.664062 0.979492)"
            />
         </clipPath>
      </defs>
   </svg>
)

export default ConversationalistSvg
